import { SocketBuilder } from "../builders"

export const printAssistentSocket = SocketBuilder('print-assistent', {
  host: process.env.REACT_APP_ASSISTENT_URL || null,
  port: process.env.REACT_APP_ASSISTENT_PORT || null,
})
